import React, {useState} from 'react';
import styles from './upload-modal-content.module.scss';
import {Row, Col, Button, Spinner} from "react-bootstrap";
import FileDropZone from "../../../../../../components/FileDropZone";
import closeIcon from "../../../../../../assets/close.svg";
import csvIcon from "../../../../../../assets/csv.svg";
import checkIcon from "../../../../../../assets/orders-table-accept.svg";
import failIcon from "../../../../../../assets/orders-table-reject.svg";
import {
  LISTING_UPLOAD_DOCUMENT_ERROR,
  LISTING_UPLOAD_DOCUMENT_SUCCESS
} from "../../../../../../helpr/constants";
import ListingService from "../../../../../../services/listing-service";

const UploadModalContent = ({context, onClose}) => {
  const [ fileState, setFileState ] = useState();
  const [ uploadFlag, setUploadFlag ] = useState();
  const [successMessage, setSuccessMessage] = useState({msg:'', show: false});
  const [errorMessage, setErrorMessage] = useState({msg:'', show: false});
  const listingService = new ListingService();
  const { applicationId, selectedDocument, setRequiredDocuments, institutionCode} = context;
  const formatDate = dt => (new Date(dt)).toISOString();

  const renderFileDropZone = () => {
    if(fileState == null){
      return <FileDropZone setFileHandler={setFileState}/>
    } else {
      return (
        <div className={styles['file-detail']}>
          <div className={styles['close-icon']} onClick={()=>removeFile()}>
            <img src={closeIcon}/>
          </div>
          <div className={styles['details']}>
            <div>{fileState.name}</div>
            <div>{ formatDate(fileState.lastModified) }</div>
          </div>
        </div>
      )
    }
  }

  const removeFile = () => setFileState(null);

  const uploadFile = async () => {
    setUploadFlag(true);
    try {
      console.log(selectedDocument.current);
      let result = await listingService.retrieveUploadPreSignedUrl(applicationId, selectedDocument.current.sortKey, fileState, institutionCode);
      await listingService.uploadRequiredDocument(result['presignedUrl'], fileState);
      setUploadFlag(false);
      setRequiredDocuments(prev => {
        const updatedList = prev.map(d => {
          if(d.sortKey === selectedDocument.current.sortKey){
            return {
              ...d,
              documentStatus: '1',
              key: fileState.name
            };
          }
          return d;
        });
        return updatedList;
      });
      showSuccessMessage(LISTING_UPLOAD_DOCUMENT_SUCCESS);
    } catch(error) {
      showErrorMessage(LISTING_UPLOAD_DOCUMENT_ERROR);
    } finally {
      setFileState(null);
      setUploadFlag(false);
      setTimeout(2000, onClose())
    }
  }

  const showSuccessMessage = (msg) => {
    setSuccessMessage({
      ...successMessage,
      msg,
      show: true
    });
    setTimeout(()=>setSuccessMessage({...successMessage, show: false}), 3600);
  }

  const showErrorMessage = (msg) => {
    setErrorMessage({
      ...errorMessage,
      msg,
      show: true
    });
    setTimeout(()=>setErrorMessage({...errorMessage, show: false}), 3600);
  }

  return (
    <div className={styles['term-sheet-upload-modal-content']}>
      <Row>
        {successMessage.show
          ? <div className={styles['success-msg']}>
            <img alt="Success" src={checkIcon} />{' '}{successMessage.msg}
          </div>
          : ''}
        {errorMessage.show
          ? <div className={styles['error-msg']}>
            <img alt="Fail" src={failIcon} />{' '}{errorMessage.msg}
          </div>
          : ''}
      </Row>
      <div className={styles['file-upload-area']}>
        { renderFileDropZone() }
      </div>
      <Row>
        <Col>
          <div className={styles['button-container']}>
              <Button onClick={() => onClose()} variant="secondary">
                Close
              </Button>
              <Button className={styles['btn']} disabled={fileState == null || uploadFlag} onClick={()=>uploadFile()}>
                { uploadFlag ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/> : 'Upload' }
              </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default UploadModalContent;
